const route = {
	path: '/accouting-ats-sales',
	name: 'accouting-ats-sales',
	meta: {
		title: 'Anexos Transaccionales Generales',
	},
	component: () => import('@/pages/atsSales/ats-sales'),
};

export default route;



// WEBPACK FOOTER //
// ./src/router/ats-sales.js